import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

export const filterA7FIAIssuersSchema = z.object({
  denomination_du_sous_jacent_contains: z.string().optional(),
  lei_contains: z.string().optional(),
  identifiant_fiscal_du_sous_jacent_contains: z.string().optional(),
  societe_mere_contains: z.string().optional(),
});

const fields: Field[] = [
  {
    name: "denomination_du_sous_jacent_contains",
    label: "Dénomination",
    type: "input",
  },
  {
    name: "lei_contains",
    label: "LEI",
    type: "input",
  },
  {
    name: "identifiant_fiscal_du_sous_jacent_contains",
    label: "Identifiant Fiscal",
    type: "input",
  },
  {
    name: "societe_mere_contains",
    label: "Dénomination Société Mère",
    type: "input",
  },
];

export function FilterA7FIAIssuers() {
  return (
    <FilterTable
      schema={filterA7FIAIssuersSchema}
      client="a7"
      tableName="a7_fia_issuers"
      fields={fields}
      customBuildPath={() => `a7-fia/a7_fia_issuers`}
    />
  );
}
